import styled from "styled-components";
export const SideBySide = styled.div `
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    padding-top: 8px;
    padding-bottom: 4px;
`;
